export const INSERT_ICONS: Record<string, string> = {
  media: 'M4 6h16v12H4zM10 9l6 3-6 3z',
  details: 'M5 7h14M5 12h10M5 17h14M3 7h.01M3 12h.01M3 17h.01',
  anchor: 'M12 6a3 3 0 1 0 .01 0M12 9v11M8 16c1.5 2 6.5 2 8 0',
  charmap: 'M5 5h6v6H5zM13 5h6v6h-6zM5 13h6v6H5zM13 13h6v6h-6z',
  emoji: 'M12 4a8 8 0 1 0 .01 0M9 10h.01M15 10h.01M8 14c1.5 2 6.5 2 8 0',
  datetime: 'M7 4v2M17 4v2M5 8h14M6 4h12v16H6z',
  pagebreak: 'M4 8h16M4 16h16M12 8v8',
  nbsp: 'M6 16h12M8 8h8v8',
  snippet: 'M8 4h8l4 4v12H8zM12 4v4h4',
}
